
import Hero from "@/components/Hero";
import DiscountBanner from "@/components/DiscountBanner";
import Services from "@/components/Services";
import About from "@/components/About";
import Contact from "@/components/Contact";
import SEO from "@/components/SEO";
import BloodDrawMedia from "@/components/BloodDrawMedia";

const Index = () => {
  
  return (
    <>
      <SEO />
      <div className="min-h-screen bg-white">
        <main>
          <Hero />
          <DiscountBanner />
          <Services />
          <BloodDrawMedia />
          <About />
          <Contact />
        </main>
      </div>
    </>
  );
};

export default Index;

